import Programs from "../components/Programs";
import WorksInProgress from "../components/WorksInProgress";
import BeforeAfter from "../components/BeforeAfter";
import Gadag from "../components/Gadag";

export default function CausesPage() {
  return (
    <div data-testid="causes-page">
      <Programs />
      <WorksInProgress />
      <BeforeAfter />
      <Gadag />
    </div>
  );
}
